import React from "react";
import { useNavigate } from "react-router-dom";

const OrdersView = () => {
  const navigate = useNavigate();

  // Simulación de pedidos
  const orders = [
    {
      id: "#12345",
      date: "15 de julio, 2024",
      total: 150.0,
      status: "Completado",
      products: ["Camisa Casual", "Jeans Denim"],
    },
    {
      id: "#12346",
      date: "20 de julio, 2024",
      total: 75.5,
      status: "Pago inicial recibido",
      products: ["Zapatos Running"],
    },
    {
      id: "#12347",
      date: "25 de julio, 2024",
      total: 200.0,
      status: "Recogida pendiente",
      products: ["Chaqueta de cuero", "Bufanda"],
    },
  ];

  const handleViewDetails = (order) => {
    navigate("/orden-estado", { state: { order } });
  };

  // Función para asignar color según estado
  const getStatusColor = (status) => {
    switch (status) {
      case "Completado":
        return "bg-green-500 text-white";
      case "Pago inicial recibido":
        return "bg-yellow-400 text-black";
      case "Recogida pendiente":
        return "bg-blue-500 text-white";
      default:
        return "bg-gray-300 text-black";
    }
  };

  return (
    <div
      className="relative flex size-full min-h-screen flex-col bg-white overflow-x-hidden"
      style={{ fontFamily: '"Plus Jakarta Sans", "Noto Sans", sans-serif' }}
    >
      <div className="layout-container flex h-full grow flex-col">
        <div className="px-40 flex flex-1 justify-center py-5">
          <div className="flex flex-col max-w-[960px] flex-1">
            <div className="flex flex-wrap justify-between gap-3 p-4">
              <p className="text-[#141414] text-[32px] font-bold leading-tight">
                Mis Compras
              </p>
            </div>

            <div className="px-4 py-3">
              <div className="flex overflow-hidden rounded-lg border border-[#e0e0e0] bg-white">
                <table className="flex-1">
                  <thead>
                    <tr className="bg-white">
                      <th className="px-4 py-3 text-left text-[#141414] w-[400px] text-sm font-medium">
                        Número de orden
                      </th>
                      <th className="px-4 py-3 text-left text-[#141414] w-[400px] text-sm font-medium">
                        Fecha
                      </th>
                      <th className="px-4 py-3 text-left text-[#141414] w-[400px] text-sm font-medium">
                        Total
                      </th>
                      <th className="px-4 py-3 text-left text-[#141414] w-60 text-sm font-medium">
                        Estado
                      </th>
                      <th className="px-4 py-3 text-left text-[#757575] w-60 text-sm font-medium">
                        Acciones
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders.map((order) => (
                      <tr key={order.id} className="border-t border-t-[#e0e0e0]">
                        <td className="px-4 py-2 w-[400px] text-[#141414] text-sm">
                          {order.id}
                        </td>
                        <td className="px-4 py-2 w-[400px] text-[#757575] text-sm">
                          {order.date}
                        </td>
                        <td className="px-4 py-2 w-[400px] text-[#757575] text-sm">
                          ${order.total.toFixed(2)}
                        </td>
                        <td className="px-4 py-2 w-60 text-sm">
                          <span
                            className={`inline-block rounded-lg h-8 px-4 flex justify-center items-center font-medium whitespace-nowrap ${getStatusColor(
                              order.status
                            )}`}
                          >
                            {order.status}
                          </span>
                        </td>
                        <td
                          className="px-4 py-2 w-60 text-[#757575] text-sm font-bold cursor-pointer"
                          onClick={() => handleViewDetails(order)}
                        >
                          Ver detalles
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrdersView;
